<template>
  <div class="alarm-task_content">
    <!--    <div class="group-title">-->
    <!--      <el-button-->
    <!--        v-if="taskType == 2"-->
    <!--        type="text"-->
    <!--        class="add-btn"-->
    <!--        @click="addSafty"-->
    <!--        >添加安全员</el-button-->
    <!--      >-->
    <!--      <el-button type="text" class="add-btn" @click="addWorkGroup"-->
    <!--        >添加执行组</el-button-->
    <!--      >-->
    <!--    </div>-->
    <div class="ioc-alarm__task">
      <div
        class="group p10"
        :class="executeTeams.length ? 'map-blur-panel__content ' : ''"
      >
        <el-scrollbar ref="scrollBar" class="scroll-bar">
          <ul class="worker-content">
            <li
              v-for="(item, ind) in executeTeams"
              :key="ind"
              class="flex-between"
              style="padding-right: 10px; border-bottom: 1px solid #181f2e"
            >
              <div>
                <span class="f12 iconfont-lunan icon-lunan-renyuan"></span>
                <span class="camera-name ml5">{{ item.name }}</span>
                <span class="camera-name ml5" v-if="item.workNo">【安全员】</span>
                <span class="camera-name ml5" v-else>【安保】</span>
              </div>
              <div class="point-icon">
                <span
                  class="el-icon-delete ml5"
                  title="删除"
                  @click="deleteWorker(ind)"
                ></span>
              </div>
            </li>
          </ul>
        </el-scrollbar>
      </div>
    </div>
    <!--    <div class="ioc-alarm__drawer__btns">-->
    <!--      &lt;!&ndash; 立即指派 &ndash;&gt;-->
    <!--      <el-button @click="addTaskInfo" :loading="dialogBtn" type="primary">-->
    <!--        {{ $t("realTimeAlarm.label.assign") }}-->
    <!--      </el-button>-->
    <!--      &lt;!&ndash; 启动预案 &ndash;&gt;-->
    <!--      <el-button-->
    <!--          @click="goPlan"-->
    <!--          :loading="dialogBtn"-->
    <!--          v-if="planType"-->
    <!--          type="primary">-->
    <!--        启动预案-->
    <!--      </el-button>-->
    <!--      &lt;!&ndash; 返回上一级 &ndash;&gt;-->
    <!--      <el-button @click="goLast" :loading="dialogBtn"> 返回</el-button>-->
    <!--    </div>-->
    <iocDialog
      ref="accounts"
      :title="$t('realTimeAlarm.label.doPerson')"
      width="460px"
      :showFooter="false"
      :showModal="false"
    >
      <el-table :data="acountList">
        <el-table-column prop="accountNumber" :label="$t('realTimeAlarm.label.user')">
        </el-table-column>
      </el-table>
    </iocDialog>
    <el-dialog
      title="添加执行组"
      :visible.sync="dialogVisible"
      width="550px"
      v-dialogDrag
      class="work-group"
      append-to-body
    >
      <work-group-tree
        ref="workGroupTree"
        :multiCheck="true"
        @groupData="getGroupData"
        :showPercentage="false"
      ></work-group-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
    <changePeople
      @confirmCallBack="confirmCallBack"
      ref="selectPeople"
      :key="key"
      :checkType="checkType"
    />
  </div>
</template>
<script>
import workGroupTree from "@src/modules/realTimeAlarm/components/workGroupTree";
import changePeople from "../../buildingConfig/components/changePeople.vue";
import iocDialog from "@components/app-dialog";
import { api } from "../api";
import { Dates } from "$utils";

export default {
  components: {
    iocDialog,
    workGroupTree,
    changePeople,
  },
  props: {
    alarm: {
      default: () => {
        return {};
      },
    },
    taskType: {
      type: String,
      default: "1",
    },
    planType: {
      type: Boolean,
      default: false,
    },
    // checkedList: {
    //   type: Array,
    //   default: [],
    // }, //选中执行组
  },
  data() {
    return {
      data: [],
      key: 0,
      checkType: "select", //radio多选
      dialogBtn: false,
      executeTeams: [],
      executeIdTeams: [],
      task: {
        code: "",
        desc: this.$t("realTimeAlarm.label.fastUp"),
        executeTeams: [
          {
            executor: [],
            executorName: [],
            accountType: [],
          },
        ],
        fileInfos: [],
        groupCode: "",
        requiredFinishedTime: "",
        userFrom: "0",
        requiredStartTime: Dates.format(new Date()),
        taskAlarmWeb: {
          alarmId: "",
          alarmLevel: 0,
          alarmTime: "",
          alarmType: "",
          deviceName: "",
          subSystem: "",
        },
        taskName: "",
        taskPriority: 0,
        taskType: 1,
        taskVisibility: 2,
      },
      currentGroup: {},
      acountGroupList: [],
      acountList: [],
      accountGroupCode: "",
      dialogVisible: false,
      checkPeolist: [], //安保
      checkPeolist2: [], //执行组
      checkedList: [],
    };
  },
  watch: {
    alarm: {
      handler(newVal, oldVal) {
        this.checkPeolist2 = [];
        this.checkPeolist = [];
        // console.log(newVal, this.taskType);
        //消防告警--
        if (this.taskType == 2) {
          // 如果不是火警 取默认人员回显 否则回显负责人
          if (newVal.commonAlarmType != "4001" && newVal.taskSecurityInfoList) {
            newVal.taskSecurityInfoList.forEach((el) => {
              this.checkPeolist2.push({
                id: el.accountNumber,
                name: el.nickName,
              });
            });
            this.executeTeams = this.checkPeolist.concat(this.checkPeolist2);
            this.filterData();
            return;
          }
          // 安保负责人回显
          if (
            newVal.firefightingAccount &&
            newVal.firefightingAccount.accountNumber != "zhangadmin"
          ) {
            this.checkPeolist2.push({
              id: newVal.firefightingAccount.accountNumber,
              name: newVal.firefightingAccount.nickName,
            });
          }
          if (newVal.securityPersonnelList) {
            // 安全人回显
            newVal.securityPersonnelList.forEach((el) => {
              if (el.workNo != "3177") {
                this.checkPeolist.push({
                  name: el.personnelName,
                  personnelCode: el.personnelCode,
                  workNo: el.workNo,
                });
              }
            });
          }
          // 备用安全员
          if (newVal.alternatePersonnelList) {
            newVal.alternatePersonnelList.forEach((el) => {
              if (el.workNo != "3177") {
                this.checkPeolist.push({
                  name: el.personnelName,
                  personnelCode: el.personnelCode,
                  workNo: el.workNo,
                });
              }
            });
          }
          this.executeTeams = this.checkPeolist.concat(this.checkPeolist2);
          this.filterData();
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    addSafty() {
      // console.log(this.executeTeams)
      this.key += 1;
      this.$nextTick(() => {
        this.$refs.selectPeople.open(this.checkPeolist, "select");
      });
    },
    confirmCallBack(data) {
      this.checkPeolist = [...data];
      this.executeTeams = this.checkPeolist.concat(this.checkPeolist2);
      this.filterData();
    },
    // 返回上一级
    goLast() {
      this.$emit("goLast");
    },
    goPlan() {
      this.$emit("goPlan");
    },
    getGroupData(data) {
      this.data = [...data];
    },
    filterData() {
      // this.executeTeams = Array.from(new Set(this.executeTeams))
      this.executeIdTeams = this.executeTeams.map((item) => {
        return item.id || item.workNo;
      });
      this.task.executeTeams[0].executor = this.executeTeams.map((item) => {
        return item.id || item.workNo;
      });
      this.task.executeTeams[0].executorName = this.executeTeams.map((item) => {
        return item.name;
      });
      this.task.executeTeams[0].accountType = this.executeTeams.map((item) => {
        if (item.id) {
          return 1;
        } else {
          return 2;
        }
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.data = [];
    },
    // 添加执行组确认
    confirm() {
      this.checkPeolist2 = [...this.data];
      this.executeTeams = this.checkPeolist.concat(this.checkPeolist2);
      this.$emit("checkPerson", this.executeTeams);
      this.filterData();
      this.dialogVisible = false;
    },
    //任务下发 新 zhangyun
    addTaskInfo() {
      this.$emit("getDesc");
      //转换父组件传过来的数据
      this.filterData();
      if (this.task.executeTeams[0].executor.length === 0) {
        this.$message.warning("请选择执行组/安保");
        return;
      }
      this.dialogBtn = true;
      this.task.taskAlarmWeb.alarmId = this.alarm.alarmId;
      this.task.taskAlarmWeb.alarmLevel = this.alarm.alarmLevel;
      this.task.taskAlarmWeb.alarmTime = this.alarm.alarmTime
        ? Dates.dayjs(this.alarm.alarmTime).format("YYYY-MM-DD HH:mm:ss")
        : "";
      this.task.taskAlarmWeb.alarmType = this.alarm.alarmType;
      this.task.taskAlarmWeb.deviceName = this.alarm.deviceName;
      this.task.taskAlarmWeb.subSystem = this.alarm.subSystem;
      this.task.taskPriority = this.alarm.alarmLevel;
      this.task.groupCode = this.alarm.groupCode;
      this.task.status = 2; // 任务下发增加status字段，启动状态
      // 告警设备ID
      this.task.taskAlarmWeb.alarmDevId = this.alarm.alarmDevId;
      // 告警任务名称只需取alarm对象中的taskName字段
      // let taskName = this.alarm.alarmName ? (this.alarm.alarmName + '-') : ""
      // this.task.taskName = taskName + this.alarm.alarmTypeLabel ? this.alarm.alarmTypeLabel : ''
      this.task.taskName = this.alarm.alarmName;
      this.$fetch(api.bas.addTaskInfo, this.task).then((response) => {
        this.dialogBtn = false;
        if (response && response.success) {
          this.checkPeolist2 = [];
          this.checkPeolist = [];
          this.executeTeams = [];
          this.task.executeTeams[0].executor = [];
          this.task.executeTeams[0].executorName = [];
          this.task.executeTeams[0].accountType = [];
          this.$message.success(this.$t("realTimeAlarm.message.issueSuc"));
          this.$emit("taskSuccess");
          // this.$parent.hide()
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    addWorkGroup() {
      this.dialogVisible = true;
      this.checkedList = this.executeTeams.map((data) => {
        if (data.id) return data.id;
      });
      this.$nextTick(() => {
        this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys(this.checkedList);
      });

      // if (this.alarm.groupCode === "200000001") {
      //   this.$nextTick(() => {
      //     let groupCodeArr = [];
      //     groupCodeArr.push(this.alarm.groupCode);
      //     this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys([
      //       "20210108000061",
      //     ]);
      //     console.log(this.$refs.workGroupTree.$refs.appAreaTree);
      //   });
      // }
      // if (this.alarm.groupCode === "20200615000045") {
      //   //宾馆中队
      //   this.$nextTick(() => {
      //     this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys([
      //       "20210125000023",
      //     ]);
      //   });
      // } else if (this.alarm.groupCode === "20200615000048") {
      //   //家属
      //   this.$nextTick(() => {
      //     this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys([
      //       "20210125000024",
      //     ]);
      //   });
      // } else if (this.alarm.groupCode === "20200615000047") {
      //   //生产区
      //   this.$nextTick(() => {
      //     this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys([
      //       "20210125000022",
      //     ]);
      //   });
      // } else if (this.alarm.groupCode === "20200615000046") {
      //   //厂前区
      //   this.$nextTick(() => {
      //     this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys([
      //       "20210125000021",
      //     ]);
      //   });
      // }
    },
    deleteWorker(ind) {
      let spliceInfo = this.executeTeams.splice(ind, 1)[0];
      this.executeIdTeams.splice(ind, 1);
      if (ind > this.checkPeolist.length - 1) {
        this.checkPeolist2.splice(ind - this.checkPeolist.length, 1);
      } else {
        this.checkPeolist.splice(ind, 1);
      }
      this.filterData();
      this.$emit("deleteWorker", spliceInfo.id);
    },
    setExecuteTeams(account) {
      if (this.executeIdTeams.indexOf(account.id) === -1) {
        this.executeTeams.push(account);
        this.executeIdTeams.push(account.id);
      } else {
        this.executeTeams.splice(this.executeIdTeams.indexOf(account.id), 1);
        this.executeIdTeams.splice(this.executeIdTeams.indexOf(account.id), 1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.alarm-task_content {
  padding: 6px 0px 12px;
  position: relative;

  .group-title {
    position: absolute;
    width: 100%;
    top: -10px;
    left: 0;
    padding: 0 13px 0 0;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    line-height: 34px;
  }

  .work-group {
    height: 500px;
    overflow: hidden;
  }

  .worker-content {
  }

  .add-btn {
    font-size: 14px;
    // margin: auto 200px;
    color: #fff;

    &:hover {
      @include set_theme_color(color, main-theme-color);
    }
  }

  // @include set_theme_color(background-color, left-menu-bg-color);
  .ioc-alarm__task {
    border: none;

    .account_panel {
      padding: 0 4px;
    }
  }
}
</style>
